import { scaleLinear, scaleTime } from 'd3-scale';

export const scale = {
  linear: scaleLinear,
  time: scaleTime,
};
